export default "__VITE_ASSET__DYwHBsUb__"